import React, { useState } from 'react';
import { DeleteLined } from '@tag/tag-icons';
import { ICellRendererParams } from 'ag-grid-community';

import AgConfirmationModal from '@/components/common/ModalWindow/AgConfirmationModal';
import styles from './remove-button.module.scss';

interface IAgGridRemoveButtonProps extends ICellRendererParams {
  onClick: () => void;
}

export default function AgGridRemoveButton({
  onClick
}: IAgGridRemoveButtonProps) {
  const [isVisibleConfirmation, setIsVisibleConfirmation] = useState(false);

  return (
    <>
      {isVisibleConfirmation && (
        <AgConfirmationModal
          isOpen={true}
          onClose={() => setIsVisibleConfirmation(false)}
          onConfirm={() => onClick()}
          title="Delete the Contract Line Record?"
        >
          The Contract Line information is not saved and continuing with this operation would delete the record.
          <br />
          Please confirm you wish to continue.
        </AgConfirmationModal>
      )}

      <div
        className={styles['remove-button']}
        onClick={() => setIsVisibleConfirmation(true)}
      >
        <DeleteLined />
      </div>
    </>
  );
}
